// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-11-19 01:34:16 +0100 (Wed, 19 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 158367 $
//  Purpose   : i18n package
// =============================================================================
export {sagas} from './sagas'

import * as reducers from './reducers'
export {reducers}

import * as actions from './actions'
export {actions}

import log from 'uix/logging'
import {iterItems, isInteger, isNumber, mapItems, get, strip, lstrip, isFunction} from 'ldash'
import {formatDate, formatDateTime} from 'uix/utils'

const replaceVars = variables => res => {
  return res.replace(/\$\{([\w\., ]*)\}/g, (g0, g1) => {
    if (g1) {
      let format = null
      let name = g1
      if (g1.includes(',')) {
        let parts = g1.split(',')
        format = strip(parts[1])
        name = strip(parts[0])
      }
      if (format === 'date') {
        return formatDate(get(variables, name, '??'))
      } else if (format === 'datetime') {
        return formatDateTime(get(variables, name, '??'))
      } else {
        return String(get(variables, name, '??'))
      }
    } else {
      return mapItems(variables, (k, v) => `${k}: ${v}`).join(', ')
    }
  })
}

export const translate = (i18n, identifier, variables, defaultValue) => {
  let post_proc = null
  if (typeof variables === 'function') {
    post_proc = variables
    variables = null
  } else if (typeof variables === 'string') {
    // ok, default can also come on arg 3
    defaultValue = variables
    variables = null
  } else if (variables) {
    post_proc = replaceVars(variables)
  }

  let res = null
  if (!identifier) {
    res = 'NO_IDENT'
  } else if (!i18n) {
    // maybe i18n data still not loaded
    res = defaultValue || identifier || 'NO_DATA'
  } else {
    if (identifier[0] === '_') {
      // remove i18n indicator: "__"
      identifier = lstrip(identifier, '_')
    }
    res = i18n[identifier]
    if (!res) {
      try {
        res = i18n[identifier.replace(/ /g, '_')] || defaultValue || identifier
      } catch (e) {
        log.error(`i18n failure for %o`, identifier)
        res = String(identifier)
      }
    }
  }
  if (post_proc) {
    res = post_proc(res)
  }
  return res
}

let formatThousands = (x, sep) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep)

export const formatNumber = (value, language) => {
  if (isInteger(value)) {
    if (language == 'de') {
      return formatThousands(value, '.')
    } else {
      return formatThousands(value, ',')
    }
  } else if (isNumber(value) && language == 'de') {
    // a float
    return value.toString().replace('.', ',')
  }
  return value.toString()
}
